import React, { useEffect, useRef } from 'react'
import '../styles/FAQ.css'
import { T } from './Translation'

function FAQ() {
  const faqRef = useRef(null)

  useEffect(() => {
    // This effect handles direct navigation to #faq from URL
    if (window.location.hash === '#faq' && faqRef.current) {
      faqRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  return (
    <section id="faq" ref={faqRef} className="faq-section">
      <h2>
        <T k="faqTitle" />
      </h2>
      <div className="faq-container">
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion1" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer1" />
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion2" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer2" />
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion3" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer3" />
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion4" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer4" />
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion5" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer5" />
            </p>
          </div>
        </details>
        <details className="faq-item">
          <summary className="faq-question">
            <T k="faqQuestion6" />
            <span className="faq-icon">+</span>
          </summary>
          <div className="faq-answer">
            <p>
              <T k="faqAnswer6" />
            </p>
          </div>
        </details>
      </div>
    </section>
  )
}

export default FAQ
